/**
 * @module LabelContent/getLabelContentOptions
 * @description 按图表类型 + 维/指数量计算 Label Content 可选项（与 UI 渲染同源）
 */

import { getAllowedLabelContentValues } from '@dbl/core/chartEditor';
import type { TChartType } from '@dbl/core/chart';

export interface ILabelContentOption {
  value: string;
  text: string;
  type: string;
}

export interface IGetLabelContentOptionsParams {
  chartType: TChartType | undefined;
  dimensionCount: number;
  metricCount: number;
  formatMessage: (descriptor: { id: string }) => string;
}

const LABEL_CONTENT_I18N: Record<string, string> = {
  percent: 'dbl_chart_percentage',
  metric: 'dbl_chart_label_metric',
  dimension: 'dbl_chart_dimension',
  total: 'dbl_chart_total',
};

/**
 * 计算数据标签 Label Content 多选可选项。
 * PercentLine 与 PercentStackBar 均提供 `percent`，其余选项规则保持历史行为。
 */
export function getLabelContentOptions(
  params: IGetLabelContentOptionsParams,
): ILabelContentOption[] {
  const { chartType, dimensionCount, metricCount, formatMessage } = params;
  return getAllowedLabelContentValues({
    chartType,
    dimensionCount,
    metricCount,
  }).map(value => ({
    value,
    text: formatMessage({ id: LABEL_CONTENT_I18N[value] || value }),
    type: value,
  }));
}
